import { Chip, styled } from "@mui/material";
export const CustomChip = styled(Chip)(({ theme }) => ({
    backgroundColor: "#00244D1A",
    color: "#00244D",
    borderRadius: "24px",
    fontWeight: 500,
    border: "1px solid #00244D33",
    "& .MuiChip-deleteIcon": {
        color: "#00244D",
    },
    backdropFilter: "blur(20px)",
    "&:hover": {
        backgroundColor: "#3192D060",
        cursor: "pointer",
    },
}));
